module.exports = __webpack_public_path__ + "static/media/T12_headboard Finishing_Vintage Eco Leather_DK Brown.0eca4b4c.png";